var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isShow && _vm.isActive)?_c('div',{staticClass:"active-announcement"},[_c('div',{class:{ 'font-bold': _vm.isGlobal }},[_vm._v(" "+_vm._s(_vm.announcement.title)+" ")]),(_vm.isGlobal)?_c('div',{},[_c('div',[_vm._v(" "+_vm._s(_vm.announcement.description)+" ")])]):_vm._e()]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }